const commonJavascriptSuggestions = [
  // LOOPS
  {
    text: 'for(var ${1:i} = 0; ${1:i} < ${2:arr}.length; ${1:i}++) {\n  ${3:logic}\n}',
    type: 'loops',
    display: 'for-loop with array',
    trigger: 'forarr',
    documentation: 'A simple for-loop to iterate over the contents of an array.'
  },
  {
    text: 'for(var ${1:i} = 0; ${1:i} < ${2:max}; ${1:i}++) {\n  ${3:logic}\n}',
    type: 'loops',
    display: 'simple for-loop',
    trigger: 'for',
    documentation: 'A simple for-loop.'
  },
  {
    text: 'while(${1:true}) {\n  ${2}\n}',
    type: 'loops',
    display: 'while-loop',
    trigger: 'while',
    documentation: 'A while loop.'
  },
  // CONDITIONALS
  {
    text: 'if (${1:cond}) {\n  ${2:body}\n}',
    type: 'conditionals',
    display: 'if conditional',
    trigger: 'if',
    documentation: 'A simple if conditional'
  },
  {
    text: 'if (${1:cond}) {\n  ${2:body}\n} else {\n  ${3:elseBody}\n}',
    type: 'conditionals',
    display: 'if-else conditional',
    trigger: 'ife',
    documentation: 'An if-else conditional'
  },
  {
    text:
      'switch (${1:subject}) {\n  case ${2:case}:\n    ${2:caseBody}\n  break;\n  default:\n    ${3:defaultBody}\n}',
    type: 'conditionals',
    display: 'switch',
    trigger: 'switch',
    documentation: 'Switch statement'
  },
  // ERROR HANDLING
  {
    text: 'try {\n  ${1:tryBody}\n} catch(${2:err}) {\n  ${3:catchBody}\n}',
    type: 'error handling',
    display: 'try-catch statement',
    trigger: 'try',
    documentation: 'A try-catch statement to do basic error handling'
  },
  {
    text:
      'try {\n  ${1:tryBody}\n} catch(${2:err}) {\n  ${3:catchBody}\n} finally {\n  ${4:finallyBody}\n}',
    type: 'error handling',
    display: 'try-catch-finally statement',
    trigger: 'fin',
    documentation: 'A finally statement will always be run regardless of errors'
  },
  // FUNCTIONS
  {
    text: 'function ${1:name}(${2:arguments}) {\n  ${3:functionBody}\n}',
    type: 'functions',
    display: 'function declaration',
    trigger: 'fun',
    documentation: 'A named function declaration.'
  },
  {
    text: '(function() {\n  ${1:body}\n})()',
    type: 'functions',
    display: 'function immediately-invoked',
    trigger: 'funi',
    documentation: 'An immediately-invoked is often used to limit the scopes of variables.'
  },
  // LINTING
  {
    text: '// disable-check',
    type: 'linting',
    display: 'linting: disable language warnings/errors for line',
    trigger: 'ignore',
    documentation: 'Disable language warnings/errors shown in the editor for this line'
  }
]

export default commonJavascriptSuggestions
